import { motion } from "framer-motion";
import { ArrowLeft, Home, MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/data/content";

export default function NotFoundPage() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#050505] px-4 text-zinc-100">
      <div className="noise-overlay" aria-hidden="true" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-20 blur-[140px]"
        style={{ background: "radial-gradient(circle, #E50914 0%, transparent 65%)" }}
      />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 max-w-xl text-center"
        data-testid="not-found-page"
      >
        <span className="font-mono-code text-xs uppercase tracking-[0.35em] text-[#E50914]">Erro 404</span>
        <h1 className="glitch mt-4 font-display text-[28vw] font-extrabold leading-none tracking-tighter sm:text-[11rem]" data-text="404">
          404
        </h1>
        <h2 className="font-display text-xl font-bold text-zinc-100 sm:text-2xl">Essa página saiu do mapa.</h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-zinc-500 sm:text-base">
          O endereço que você tentou acessar não existe ou foi movido. Sem problema — o caminho de volta é curto.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            data-testid="not-found-home"
            href="/"
            className="btn-red-glow inline-flex items-center gap-2.5 rounded-full bg-[#E50914] px-7 py-3.5 font-mono-code text-xs font-bold uppercase tracking-widest text-white"
          >
            <Home className="h-4 w-4" />
            Página inicial
          </a>
          <a
            data-testid="not-found-whatsapp"
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 rounded-full border border-[#2A2A33] px-7 py-3.5 font-mono-code text-xs font-bold uppercase tracking-widest text-zinc-300 transition-colors hover:border-[#E50914]/60 hover:text-white"
          >
            <MessageCircle className="h-4 w-4 text-[#E50914]" />
            Falar com o Luiz
          </a>
        </div>
        <button
          data-testid="not-found-back"
          onClick={() => window.history.back()}
          className="mt-8 inline-flex items-center gap-2 text-xs text-zinc-500 transition-colors hover:text-[#E50914]"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Voltar para a página anterior
        </button>
      </motion.div>
    </div>
  );
}
